module.exports = __webpack_public_path__ + "static/scale-model-of-mickey's-toontown-in-garden-grove-california-237153f0b6d88fa7adbc09e91793a047.png";